import { convertNameSelectMDefault } from '@/utils';

import { DefaultOptionType } from 'antd/es/select';

import { MasterInfoEnum } from './common.constant';

export const OPTION_SELECT_ALL = {
	value: '',
	label: 'all',
	type: '',
};

export const OPTION_SELECT = {
	value: '',
	label: 'select',
	type: '',
};

export const OPTION_SELECT_TYPE = {
	value: '',
	label: '구분 전체',
	type: '',
};

export const DEFAULT_YEARS_SELECT = {
	value: '',
	label: 'filter-date.select-year',
	type: '',
} as DefaultOptionType;

export const PROGRAM_OPTION_SELECT_ALL = {
	value: '',
	label: 'all-program',
};

export const APPLICANT_OPTION_SELECT_ALL = {
	value: '',
	label: '근로자 전체',
};

export const OPTION_SELECT_ALL_DOCUMENT = {
	value: '',
	label: '서류 선택',
	type: '',
};

export const PROGRAM_OPTION_SELECT_ALL_V2 = [
	{
		value: 'ALL',
		label: 'all',
	},
	{
		value: 'ALL_PROGRAM',
		label: 'all-program',
	},
];

export const DISTRICT_OPTION_SELECT_ALL_V2 = [
	{
		value: 'ALL',
		label: 'all',
	},
	{
		value: 'ALL_DISTRICT',
		label: 'all-town-district',
	},
];

export const APPLICANT_MAPPING_OPTION_SELECT = {
	value: '',
	label: '연관 근로자 전체',
};

export const FRANCHISE_MAPPING_OPTION_SELECT = {
	value: '',
	label: '연관 사업장 전체',
};

export const OPTION_AGE_RANGE_SELECT = {
	value: '',
	label: '연령대',
};

export const OPTION_SELECT_MASTER = (
	type?: MasterInfoEnum,
	firstOptionText?: string
) => {
	return {
		value: '',
		label: firstOptionText || convertNameSelectMDefault(type),
		type: '',
	};
};

export const OPTION_SELECT_ALL_COMMON = (label: string) => ({
	value: '',
	label: label,
	type: '',
});
